import resetPassword from './resetPassword'

export const resetPasswordPromise = resetPassword
